import loadable from '@loadable/component';
export var manifest = {
  'Rating.App': {
    device: {
      desktop: {
        component: loadable({
          resolved: {},
          chunkName: function chunkName() {
            return "RatingAppDesktop";
          },
          isReady: function isReady(props) {
            var key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },
          importAsync: function importAsync() {
            return import(
            /* webpackChunkName: "RatingAppDesktop" */
            './app-rating-desktop');
          },
          requireAsync: function requireAsync(props) {
            var _this = this;

            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function (resolved) {
              _this.resolved[key] = true;
              return resolved;
            });
          },
          requireSync: function requireSync(props) {
            var id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },
          resolve: function resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./app-rating-desktop");
            }

            return eval('require.resolve')("./app-rating-desktop");
          }
        }, {
          resolveComponent: function resolveComponent(m) {
            return m.AppRatingDesktop;
          }
        })
      },
      mobile: {
        component: loadable({
          resolved: {},
          chunkName: function chunkName() {
            return "RatingAppMobile";
          },
          isReady: function isReady(props) {
            var key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },
          importAsync: function importAsync() {
            return import(
            /* webpackChunkName: "RatingAppMobile" */
            './app-rating-mobile');
          },
          requireAsync: function requireAsync(props) {
            var _this = this;

            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function (resolved) {
              _this.resolved[key] = true;
              return resolved;
            });
          },
          requireSync: function requireSync(props) {
            var id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },
          resolve: function resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./app-rating-mobile");
            }

            return eval('require.resolve')("./app-rating-mobile");
          }
        }, {
          resolveComponent: function resolveComponent(m) {
            return m.AppRatingMobile;
          }
        })
      }
    }
  },
  'Rating.Bank': {
    device: {
      desktop: {
        component: loadable({
          resolved: {},
          chunkName: function chunkName() {
            return "RatingBankDesktop";
          },
          isReady: function isReady(props) {
            var key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },
          importAsync: function importAsync() {
            return import(
            /* webpackChunkName: "RatingBankDesktop" */
            './bank-rating-desktop');
          },
          requireAsync: function requireAsync(props) {
            var _this = this;

            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function (resolved) {
              _this.resolved[key] = true;
              return resolved;
            });
          },
          requireSync: function requireSync(props) {
            var id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },
          resolve: function resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./bank-rating-desktop");
            }

            return eval('require.resolve')("./bank-rating-desktop");
          }
        }, {
          resolveComponent: function resolveComponent(m) {
            return m.BankRatingDesktop;
          }
        })
      },
      mobile: {
        component: loadable({
          resolved: {},
          chunkName: function chunkName() {
            return "RatingBankMobile";
          },
          isReady: function isReady(props) {
            var key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },
          importAsync: function importAsync() {
            return import(
            /* webpackChunkName: "RatingBankMobile" */
            './bank-rating-mobile');
          },
          requireAsync: function requireAsync(props) {
            var _this = this;

            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function (resolved) {
              _this.resolved[key] = true;
              return resolved;
            });
          },
          requireSync: function requireSync(props) {
            var id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },
          resolve: function resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./bank-rating-mobile");
            }

            return eval('require.resolve')("./bank-rating-mobile");
          }
        }, {
          resolveComponent: function resolveComponent(m) {
            return m.BankRatingMobile;
          }
        })
      }
    }
  }
};